import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ConfirmationService extends Service {
	@tracked isOpen = false;
	@tracked title = '';
	@tracked message = '';
	@tracked confirmLabel = 'Delete';
	@tracked cancelLabel = 'Cancel';
	@tracked confirmStyle = 'danger';

	_resolve = null;
	_reject = null;

	confirm(options = {}) {
		this.title = options.title || 'Confirm';
		this.message = options.message || 'Are you sure?';
		this.confirmLabel = options.confirmLabel || 'Delete';
		this.cancelLabel = options.cancelLabel || 'Cancel';
		this.confirmStyle = options.confirmStyle || 'danger';
		this.isOpen = true;

		return new Promise((resolve, reject) => {
			this._resolve = resolve;
			this._reject = reject;
		});
	}

	@action
	onConfirm() {
		this.isOpen = false;
		if (this._resolve) {
			this._resolve(true);
			this._resolve = null;
			this._reject = null;
		}
	}

	@action
	onCancel() {
		this.isOpen = false;
		if (this._resolve) {
			this._resolve(false);
			this._resolve = null;
			this._reject = null;
		}
	}
}
